module.exports = __webpack_public_path__ + "img/Katze.8be9d49d.png";